export interface IValidateToken<T = any> {
    token: string;
    obj?: T;
    msg?: string;
}